"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._ServerSideEncryptionByDefault = {
    type: "structure",
    required: ["SSEAlgorithm"],
    members: {
        SSEAlgorithm: {
            shape: {
                type: "string"
            }
        },
        KMSMasterKeyID: {
            shape: {
                type: "string",
                sensitive: true
            }
        }
    }
};
//# sourceMappingURL=_ServerSideEncryptionByDefault.js.map